import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output
} from '@angular/core';

@Directive({
  selector: '[video]'
})
export class VideoDirective {

  constructor(
    private element: ElementRef
  ) {
  }

  @Output() onThumbnailGenerated = new EventEmitter<any>();

  @HostListener('loadstart') onloadstart() {
    console.log('loadstart()');
  }

  @HostListener('loadeddata') loadeddata() {
    console.log('loadeddata()');
    this.element.nativeElement.classList.add('loaded');

    if (this.element.nativeElement.dataset &&
        this.element.nativeElement.dataset.new === 'true') {
      this.generateThumbnail();
    }
  }

  private generateThumbnail() {
    console.log('generateThumbnail()');

    let canvas = <HTMLCanvasElement> document.createElement('canvas');
    canvas.setAttribute('crossOrigin', 'anonymous');
    let ctx = canvas.getContext('2d');
    canvas.width = 800;
    canvas.height = 450;
    ctx.drawImage(this.element.nativeElement, 0, 0, 800, 450);
    let videoFrame = {
      image: canvas.toDataURL('image/jpeg'),
      contentType: 'image/jpeg',
      fileName: this.getFrameName(this.element.nativeElement.id),
      videoFileName: this.element.nativeElement.id
    };

    this.onThumbnailGenerated.emit(videoFrame);
  }

  private getFrameName(name: string): string {
    let arrayName = name.split('.');

    return arrayName[0] + '-thumbnail.jpeg';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form-media/video.directive.ts